import {
  Document,
  Paragraph,
  Table,
  TableRow,
  TableCell,
  WidthType,
  Packer,
  AlignmentType,
  BorderStyle,
} from 'docx';
import FileSaver from 'file-saver';
import { DateUtil } from '@src/packages/utils/dates';
import {
  getTimeTrackerDocxDocumentRunDefaults,
  TIME_TRACKER_EXPORT_FONT_NAME,
} from '../../../utils/timeTrackerExportFont';
import { createTimeTrackerDocxTextRun as createTextRun } from '../../../utils/timeTrackerDocxTextRun';

const tableBorders = {
  top: { style: BorderStyle.SINGLE, size: 1, color: '000000' },
  bottom: { style: BorderStyle.SINGLE, size: 1, color: '000000' },
  left: { style: BorderStyle.SINGLE, size: 1, color: '000000' },
  right: { style: BorderStyle.SINGLE, size: 1, color: '000000' },
  insideHorizontal: { style: BorderStyle.SINGLE, size: 1, color: '000000' },
  insideVertical: { style: BorderStyle.SINGLE, size: 1, color: '000000' },
};

export const downloadActiveEnterprisesAsDocx = (
  data,
  columns,
  fileName = 'active_enterprises',
  formatIdCard,
) => {
  const sectionChildren = [];

  // Add title
  sectionChildren.push(
    new Paragraph({
      children: [createTextRun('Reporte de Empresas Activas', { bold: true })],
      alignment: AlignmentType.CENTER,
      spacing: { after: 400 },
    }),
  );

  // Create table rows
  const tableRows = [];

  // Create header row
  const headerRow = new TableRow({
    children: columns.map(
      column =>
        new TableCell({
          children: [
            new Paragraph({
              children: [createTextRun(column.title || '', { bold: true })],
            }),
          ],
          width: { size: 100 / columns.length, type: WidthType.PERCENTAGE },
        }),
    ),
  });
  tableRows.push(headerRow);

  // Add data rows
  data.forEach(record => {
    const dataRow = new TableRow({
      children: columns.map(column => {
        let value = record[column.dataIndex] || '';

        if (column.dataIndex === 'auditUrl' && record.auditUrl) {
          value = record.auditUrl;
        }

        if (column.dataIndex === 'contractExpiryDate' && record.contractExpiryDate) {
          value = DateUtil.toDateString(record.contractExpiryDate, DateUtil.DEFAULT_DT_DATE_FORMAT);
        }

        if (column.dataIndex.toLowerCase() === 'rut' && record?.RUT) {
          value = formatIdCard(record.RUT);
        }

        return new TableCell({
          children: [new Paragraph({ children: [createTextRun(value.toString())] })],
          width: { size: 100 / columns.length, type: WidthType.PERCENTAGE },
        });
      }),
    });
    tableRows.push(dataRow);
  });

  // Create the table
  const table = new Table({
    rows: tableRows,
    width: { size: 100, type: WidthType.PERCENTAGE },
    borders: tableBorders,
  });

  sectionChildren.push(table);

  const doc = new Document({
    styles: {
      default: {
        document: {
          run: getTimeTrackerDocxDocumentRunDefaults(),
          paragraph: {
            font: TIME_TRACKER_EXPORT_FONT_NAME,
          },
        },
      },
    },
    sections: [
      {
        children: sectionChildren,
        properties: {
          page: {
            size: {
              orientation: 'landscape',
            },
          },
        },
      },
    ],
  });

  Packer.toBlob(doc).then(blob => {
    const date = new Date().toISOString().split('T')[0];
    const name = `${fileName}_${date}`;
    FileSaver.saveAs(blob, `${name}.docx`);
  });
};
